export default "__VITE_ASSET__gA3Wi3J7__"